'use strict';

import GoogleMap from './../common/GoogleMap';
import buildComparisonAlert from './../common/buildComparisonAlert';

export default function searchMap () {
    const MAP_SELECTOR = '.js-search-map';

    let $objects = $('.js-search-object'),
        $checkAllBtn = $('.js-match-all-objects'),
        $triggerLabel = $objects.find('.js-object-label'),
        objectsCount = $objects.length,
        bounds;

    if (!objectsCount) {
        return;
    }

    let makeIcon = (color) => ({
        path: 'M25,0C14.65,0,6.25,8.4,6.25,18.75 C6.25,29.1,25,50,25,50s18.75-20.9,18.75-31.25C43.75,8.4,35.35,0,25,0z',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: color,
        strokeWeight: 0,
        scale: 0.575,
        size: new google.maps.Size(38, 50),
        origin: new google.maps.Point(0, 0),
        anchor: new google.maps.Point(19, 50),
        labelOrigin: new google.maps.Point(24, 20)
    });

    let toggleObject = (idx, state = undefined) => {
        let isStateted = typeof state !== 'undefined',
            $currentObject = $objects.filter(`[data-id="${idx}"]`),
            wasActive = $currentObject.hasClass('active');

        if (
            !isStateted ||
            isStateted && wasActive !== state
        ) {
            $currentObject.toggleClass('active');

            let currentMarker = searchMap.$gMarker.filter(function (el) {
                return parseInt(el.rmbID) === parseInt(idx);
            })[0];

            if (typeof currentMarker === 'undefined') {
                return;
            }

            currentMarker.setIcon(makeIcon(!wasActive ? '#ffa200' : '#666'));

            $.ajax({
                method: 'POST',
                url: $currentObject.attr('data-href').replace('__state', !wasActive).replace('__dateTimeJs', new Date().getTime()),
            }).done((data) => {
                let $alertHld = $('.js-alerts-hld'),
                    $alert = $('.js-alert[data-type="comparison"]'),
                    response = data ? JSON.parse(data) : null;

                if (!response) {
                    return;
                }

                if ($alert.length) {
                    if (response.count) {
                        $alert.siblings().remove();
                        /* jshint camelcase:false */
                        $alert.find('.js-alert-msg').text(response.count_str);
                        /* jshint camelcase:true */
                    } else {
                        $alert.remove();
                        /* jshint camelcase:false */
                        $alertHld.append($([
                            `<div class="alert alert-error t-a-c" data-type="comparison">`,
                                response.count_str,
                            `</div>`].join('')));
                        /* jshint camelcase:true */
                    }
                } else if (response.count) {
                    /* jshint camelcase:false */
                    $alertHld.append(buildComparisonAlert(response.count_str));
                    /* jshint camelcase:true */
                }
            });
        }
    };

    let searchMap = new GoogleMap({
        mapSelector: MAP_SELECTOR,
        callback () {
            bounds = new google.maps.LatLngBounds();

            $objects.each((idx, el) => {
                let $el = $(el);

                searchMap.setMarker({
                    rmbID: $el.attr('data-id'),
                    lat: $el.attr('data-lat'),
                    lng: $el.attr('data-lng'),
                    label: {
                        color: '#fff',
                        text: `${idx + 1}`
                    },
                    marker: {
                        icon: makeIcon('#666')
                    }
                });
            });

            this.$gMarker.forEach((item) => {
                item.addListener('click', function() {
                    toggleObject(item.rmbID);
                });

                bounds.extend(item.getPosition());
            });

            searchMap.$gMap.fitBounds(bounds);

            $objects.filter('.active').each((id, el) => {
                let idx = $(el).attr('data-id');
                let currentMarker = searchMap.$gMarker.filter(function (el) {
                    return parseInt(el.rmbID) === parseInt(idx);
                })[0];

                if (typeof currentMarker === 'undefined') {
                    return;
                }

                currentMarker.setIcon(makeIcon('#ffa200'));
            });
        }
    });

    $triggerLabel.on('click', function (e, state) {
        e.preventDefault();

        let id = $(this).attr('data-id');

        toggleObject(id , state);
    });

    $checkAllBtn.on('click', function (e) {
        e.preventDefault();

        let $this = $(this),
            state = $this.attr('data-state') === 'true';

        if (!state) {
            $this.text($this.attr('data-uncheck'));
        } else {
            $this.text($this.attr('data-check'));
        }

        $this.attr('data-state', !state);

        $triggerLabel.trigger('click', !state);
    });

    $(window).on('gMap:centerMap', () => {
        searchMap.$gMap.fitBounds(bounds);
    });
}
